export const sourceName = 'boards';
export const SitesVisibility = {
  All: 'all',
  Current: 'current'
};
export const TeamAvailability = {
  On: 'on',
  Off: 'off'
};
export const SystemBoard = {
  Favorites: 'fav'
};